module.exports = __webpack_public_path__ + "cfd723a6f48b0812efef2058c12afee2.png";